import { round } from 'lodash-es';
import { numberOfDecimalsFromValue } from './numbers/number-of-decimals-from-value';

/**
 * Rounds a value based on a total value mainly used for displaying values on axes for diagrams to ensure that they are rounded in the same way.
 * @param value
 * @param total
 * @returns the rounded value and the number of decimals, to be used with formatNumberService.formatWithBoardLanguage;
 */
export function dynamicRound(value: number, total: number): { decimals: number; roundedValue: number } {
  const decimals = numberOfDecimalsFromValue(total);
  return { decimals, roundedValue: round(value, decimals) };
}
